import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { sectionSettingsConstants, useSectionSettings } from '..';

export function useDeleteSection() {
  const qc = useQueryClient();
  const {
    methods: { setTrash }
  } = useSectionSettings();
  const [{ page = 1, search }] = useQueryParams({
    page: NumberParam,
    search: StringParam
  });

  return useMutation(
    async (payload?: number) => {
      const { data } = await $api.delete(`/v1/department/${payload}`);

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async data => {
        await qc.invalidateQueries([sectionSettingsConstants.queryKeys.DEPARTMENTS, page, search]);

        setTrash({
          visible: false,
          id: undefined
        });

        showMessage(data?.message, data?.accept);
      }
    }
  );
}
